type Props = {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
};

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: Props) {
  return (
    <div className={align === 'center' ? 'text-center mx-auto max-w-2xl' : ''}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-primary-600">
          <span className="h-1 w-6 rounded-full bg-primary-500" aria-hidden="true"></span>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}